import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import MiniPopup from 'components/atoms/descriptionPopup';

const QuestionBool = ({ question, current, canEditPage }) => {
  const questionGuid = question.guid;
  const {
    ccmPatientDetails: { setAnswer },
  } = useDispatch();

  const answerGroups = useSelector((state) => state.ccmPatientDetails.answers);

  const selectedAnswerGuid = answerGroups[current][question.guid];
  const colorClass = canEditPage ? 'item--active' : 'item--disabled';

  return (
    <div className="question">
      <div className="question__answers">
        {question.answers
          .sort((a, b) => b.score - a.score)
          .map((answer) => (
            <button
              disabled={!canEditPage}
              key={answer.guid}
              className={`question__answers-item ${
                selectedAnswerGuid === answer.guid
                  ? `question__answers-${colorClass}`
                  : ''
              }`}
              onClick={() =>
                setAnswer({
                  questionGuid: [questionGuid],
                  answerGuid: answer.guid,
                  group: current,
                })
              }
            >
              {answer.answer}
            </button>
          ))}
      </div>
      <div className="question__question">
        <div className="question__question-text">
          {question.question}
          {question.description && (
            <span className="question__popup-icon">
              <MiniPopup msg={question.description} />
            </span>
          )}
        </div>
        {question.notes &&
          question.notes.split('|').map((note, index) => (
            <div
              key={index}
              className={classnames('question__question-note', {
                'question__question-note-disabled': !canEditPage,
              })}
            >
              {note}
            </div>
          ))}
      </div>
    </div>
  );
};

QuestionBool.propTypes = {
  question: PropTypes.object.isRequired,
  current: PropTypes.number.isRequired,
  canEditPage: PropTypes.bool,
};

export default QuestionBool;
